function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "link-line",
  transform: "translate(-6.353 -6.085)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11915",
  "data-name": "Path 11915",
  d: "M22.832,29.416l-3.6,3.575a5.861,5.861,0,0,1-8.234,0,5.743,5.743,0,0,1,0-8.132l6.872-6.813a5.861,5.861,0,0,1,8.234,0,5.656,5.656,0,0,1,1.465,2.505,2.93,2.93,0,0,0,.4-.4l1.89-1.875a8.63,8.63,0,0,0-1.685-2.374,8.791,8.791,0,0,0-12.366,0L8.913,22.779a8.659,8.659,0,0,0,0,12.293,8.791,8.791,0,0,0,12.366,0l5.348-5.3h-.733a11.721,11.721,0,0,1-3.062-.352Z",
  transform: "translate(0 3.386)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11916",
  "data-name": "Path 11916",
  d: "M35.262,8.627a8.791,8.791,0,0,0-12.366,0l-5.348,5.3h.718a11.721,11.721,0,0,1,3.077.41l3.6-3.575a5.861,5.861,0,0,1,8.234,0,5.743,5.743,0,0,1,0,8.132L26.31,25.711a5.861,5.861,0,0,1-8.234,0,5.656,5.656,0,0,1-1.465-2.505,2.93,2.93,0,0,0-.41.337l-1.89,1.875a8.63,8.63,0,0,0,1.685,2.374,8.791,8.791,0,0,0,12.366,0l6.872-6.813a8.674,8.674,0,0,0,0-12.293Z",
  transform: "translate(3.701 0)",
  fill: "#ac1ede"
}));

var SvgLinkLine = function SvgLinkLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.134,
    height: 34.914,
    viewBox: "0 0 35.134 34.914",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-line.0e161f61.svg";
export { ForwardRef as ReactComponent };